import { useContext, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PasswordStrengthBar from "react-password-strength-bar";
import { Link, useNavigate } from "react-router-dom";
import { registerUser, setCurrentUser } from "../../api/userService";
import Button from "../../components/Button/Button";
import Layout from "../../components/Layout/Layout";
import Logo from "../../components/Logo/Logo";
import TextInput from "../../components/TextInput/TextInput";
import UserContext from "../../context/UserContext";
import "./Registration.scss";

const checkPasswordMeetsRequirements = (password) => {
  if (password.includes(" ")) {
    return false;
  } else if (password.length < 8) {
    return false;
  } else if (!/^(?=.*[a-zA-Z]).*$/.test(password)) {
    return false;
  } else if (!/^(?=.*[0-9]).*$/.test(password)) {
    return false;
  } else {
    return true;
  }
};

const Registration = ({ isAdmin }) => {
  const [childName, setChildName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [captchaComplete, setCaptchaComplete] = useState(false);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const getIdFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("schoolId")) {
      return urlParams.get("schoolId");
    }
    return "";
  };

  const schoolId = getIdFromURL();

  const handleRegister = async (event) => {
    event.preventDefault();

    if (checkPasswordMeetsRequirements(password) == false) {
      setErrorMessage(
        "Password must not include spaces and must include at least 1 number and be at least 8 characters long!"
      );
      return;
    }

    const result = await registerUser({
      email,
      password,
      childName,
      schoolId,
      isAdmin,
    });

    if (result.isSuccess) {
      setCurrentUser(setUser);
      navigate("/dashboard");
    } else {
      setErrorMessage(result.error);
      console.log("there was an error registering this user");
    }
  };

  const handleUpdateFirstName = (event) => {
    setChildName(event.target.value);
  };

  const handleUpdateEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleUpdatePassword = (event) => {
    setPassword(event.target.value);
  };

  const onChange = () => {
    setCaptchaComplete(true);
  };

  return (
    <Layout showNavbar={false}>
      <div className="registration">
        <Logo />
        <form className="registration__form" onSubmit={handleRegister}>
          <h1 className="registration__heading">Create your account</h1>
          {errorMessage && errorMessage}
          <TextInput
            labelText={isAdmin ? "Admin Name" : "Child Name"}
            onChangeEvent={handleUpdateFirstName}
            inputType="text"
          />
          <TextInput
            labelText="Email Address"
            onChangeEvent={handleUpdateEmail}
            inputType="email"
          />
          <TextInput
            labelText="Password"
            onChangeEvent={handleUpdatePassword}
            inputType={"password"}
            visibilityOption={true}
          />

          <PasswordStrengthBar password={password} />
          <ReCAPTCHA
            sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
            onChange={onChange}
            theme="dark"
            data-testid="recaptcha-sign-in"
          />
          <Button
            label="Create your account"
            type="submit"
            isDisabled={captchaComplete ? false : true}
          />

          <p className="registration__bottom-text">
            Already have an account?{" "}
            <Link to="/" className="registration__log-in-link">
              Sign in
            </Link>
          </p>
        </form>
      </div>
    </Layout>
  );
};

export default Registration;
